<template>
  <div class="mx-0 px-0">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl">
      <div class="text-container">
        <div class="title-area">
          <div class="d-flex">
            <span class="float-left survey-type-badge btn-primary">
                <fa-icon
                  name="clipboard-list"
                  size="6x"
                />
            </span>
            <h2>
                <span
                  id="set-information"
                  class="pl-3 pt-"
                >
                  {{ texts[1] }}
                </span>
              <!-- <span
                class="float-right vertical-middle text-right"
              >

              </span> -->
            </h2>
          </div>
        </div>
        <!-- Preface -->
        <b-card
          v-if="step==0"
          class="border-0"
          title=""
        >
          <div class="">
              <SelectLanguage
                enabled-for="language_enabled_checklist"
                :defaultlanguage="language"
                @languagechange="setlanguage"
              />
          </div>
          <p>
            {{ texts[2] }}
          </p>
          <p>
            {{ texts[3] }}
          </p>
          <p>
            {{ texts[4] }}
          </p>
        </b-card>
        <!-- Questions -->
        <b-card
          v-if="step>0&&step<=questions.length"
          class="border-0"
          title=""
        >
          <h3 class="my-4 py-4">
            <span>
              {{ questions[step-1].question_number }}.
            </span>
            {{ questions[step-1].question_text }}
          </h3>
          <div
            class="row"
          >
            <b-button-group
              horizontal
              class="btn-group btn-group-horizontal btn-group-toggle col text-center"
            >
              <label
                v-for="index in options.length"
                :id="index"
                :key="index"
                class="btn btn-questionnaire btn-questionnaire-horizontal btn-iphone text-center py-4"
                :class="(answers[step] != null)&&(answers[step]===index)||currentoption===index?'btn-primary':'btn-outline-primary'"
                @click.prevent="currentoption=index;setanswer(step,index)"
              >
                <span
                  v-if="answers[step]&&answers[step]==index"
                  class="mr-2"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 512 512"
                    focusable="false"
                    class="white fa-icon"
                  >
                    <path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z" />
                  </svg>
                </span>
                <input
                  type="radio"
                  class="text-center"
                >{{ options[index-1] }}
              </label>
            </b-button-group>
          </div>
        </b-card>
        <!-- Result -->
        <b-card
          v-if="step>questions.length"
          class="border-0"
          title=""
        >
          <h3 class="my-4 py-4">
            {{ texts[5] ? texts[5] : 'Result:' }} {{ result }}
          </h3>
          <div
            class="row"
          >
            <div class="d-xs-none col-md-1" />
            <div class="thermometer ml-4 mr-2 text-center">
              <div
                class="indicator"
                style="position:relative"
                :style="{ top: indicatortop+'px'}"
              >
                {{ result }}
              </div>
            </div>
            <div class="col-6 mr-2">
              <div style="top: 0px; height:110px;">
                {{ texts[6] ? texts[6] : 'developable to an extremely large extent' }}
              </div>
              <div style="top: 110px; height:110px;">
                {{ texts[7] ? texts[7] : 'developable to a fairly large extent' }}
              </div>
              <div style="top: 230px; height:120px;">
                {{ texts[15] ? texts[15] : 'developable to some extent' }}
              </div>
              <div style="top: 355px;">
                {{ texts[8] ? texts[8] : 'not at all developable' }}
              </div>
            </div>
          </div>
        </b-card>
        <!-- Navigation -->
        <b-card
          class="border-0"
          title=""
        >
          <b-row>
            <div class="col-12 mt-5">
              <b-link
                v-if="step==0"
                to="/create"
                class="float-left"
              >
                <b-button variant="secondary">
                  &lt;<span> {{ texts[9] ? texts[9] : 'Back' }}</span>
                </b-button>
              </b-link>
              <b-button
                v-if="step>0"
                class="float-left"
                variant="secondary"
                @click="prevstep"
              >
                &lt;<span> {{ texts[9] ? texts[9] : 'Back' }}</span>
              </b-button>
              <b-button
                v-if="step==0"
                class="float-right"
                variant="primary"
                @click="nextstep"
              >
                <span>{{ texts[10] ? texts[10] : 'Next' }} </span>&gt;
              </b-button>
              <b-button
                v-if="step==7"
                class="float-right"
                variant="primary"
                @click="startover"
              >
                <span>{{ texts[11] ? texts[11] : 'Start over' }}</span>
              </b-button>
            </div>
          </b-row>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import SelectLanguage from './SelectLanguage.vue'

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export default {
  name: 'Checklist',
  components: {
    Navbar,
    Breadcrumb,
    SelectLanguage
  },
  data () {
    return {
      language: 38,
      step: 0,
      questions: [],
      settinganswer: false,
      currentoption: 0,
      answers: [],
      result: 0,
      texts: [],
      options: [],
      indicatortop: '200px'
    }
  },
  watch: {
    language () {
      this.gettexts(this.language)
      this.questions_get()
      localStorage.setItem('GDQChecklistLanguage', this.language)
    }
  },
  mounted () {
    const userlang = localStorage.getItem('GDQChecklistLanguage')
    if (userlang) { this.language = userlang }
    this.gettexts(this.language)
    this.questions_get()
  },
  methods: {
    gettexts (language) {
      let texts = []
      const filter = {
        language_id: {
          operator: '=',
          value: language || 38
        }
      }
      const payload = {
        table_name: 'g_checklisttexts',
        filter: filter
      }
      this.$store.dispatch('records_readall', payload)
        .then((resp) => {
          const r = resp.data.result
          for (let i = 0; i < r.length; i++) {
            texts[r[i].text_number] = r[i].text
          }
          this.texts = texts
          this.options = []
          this.options.push(texts[12] ? texts[12] : 'Not at all')
          this.options.push(texts[13] ? texts[13] : 'Partly')
          this.options.push(texts[14] ? texts[14] : 'Completely')
        })
    },
    setlanguage (value) {
      this.language = parseInt(value)
    },
    startover () {
      const userlang = localStorage.getItem('GDQChecklistLanguage')
      if (userlang) { this.language = userlang }
      this.gettexts(this.language)
      this.questions_get()
      this.step = 0
      this.answers = []
    },
    questions_get () {
      this.$store.dispatch('checklistquestions_fetch', { language_id: this.language || 38 })
        .then((resp) => {
          this.questions = resp.data
        })
    },
    nextstep: async function (millisecs) {
      await sleep(millisecs).then(() => {
        this.step++
        this.result = 0
        for (let i = 1; i < 7; i++) {
          this.result += this.answers[i]
        }
        // this.indicatortop = 357; // bottom = 6 points
        // this.indicatortop = 0; // top? = 18 points
        // point spread = 12
        this.indicatortop = (12 - (this.result - 6)) * (357 / 12)
      })
    },
    prevstep: function () {
      this.step--
    },
    setanswer: async function (question_number, answer) {
      if (this.settinganswer) { return false }
      this.settinganswer = true
      this.answers[question_number] = answer
      await this.nextstep(300)
        .then(() => {
          this.settinganswer = false
          this.currentoption = 0
        })
    }
  }
}
</script>
<style scoped>
.thermometer {
  width: 100px;
  height: 360px;
  background: rgb(255,0,0);
  background: linear-gradient(0deg, #e59ea1 0%, #fded97 50%, #8bcac1 100%);
}
.indicator {
  width: 100px;
  border-top: 2px solid #000;
}

</style>
